import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from '@quantum-theme/core/_config/api/api';
import { Observable, of } from 'rxjs';
import { ResponseModel } from '@_core/models/response';
import { QueryUtilsModel } from '@_core/models/logic-custom-query/query-utils.model';
import { QueryCriteria } from '@_core/models/logic-custom-query/query-criteria.model';
import { SystemCodeMap } from '@quantum-theme/core/_config/system-code-map';

const baseUrlAPI = API.baseUrl;
const lessonAPI = API.training + '/lessons';

@Injectable()
export class LessonService {
  constructor(
    private http: HttpClient,
  ) { }

  getQuestionSetList(query?): Observable<ResponseModel> {
    const queryUtils: QueryUtilsModel = this.genQueryUtils();
    queryUtils.queryCriterias = [
      ...(query ? [new QueryCriteria('name', query, 'like', 'and')] : []),
    ];  
    return this.http.post<ResponseModel>(baseUrlAPI + '/testSet/list', queryUtils);
  }

  getQuizList(query?): Observable<ResponseModel> {
    const queryUtils: QueryUtilsModel = this.genQueryUtils();
    queryUtils.queryCriterias = [
      ...(query ? [new QueryCriteria('name', query, 'like', 'and')] : []),
    ];  
    return this.http.post<ResponseModel>(baseUrlAPI + '/testPaper/list', queryUtils);
  }

  private genQueryUtils(): QueryUtilsModel {
    return {
      pagingTool: {
        currentPage: 1,
        pageSize: 1000,
      },
    };
  }

  getCourseList(query?, selectedOrg?): Observable<ResponseModel> {
    const queryUtils: QueryUtilsModel = this.genQueryUtils();
    queryUtils.queryCriterias = [
      ...(query ? [new QueryCriteria('code', query, 'like', 'and')] : []),
      ...([new QueryCriteria('lesson.status', '_SYS_EL_3_2', '=')]),
      ...(selectedOrg ? [new QueryCriteria('orgId', selectedOrg.id, 'in')] : []),
    ];
    return this.http.post<ResponseModel>(lessonAPI + '/downList', queryUtils);
  }
}
